import styled from 'styled-components';
import theme from './theme';

const Nav = styled.nav`
  width: 100%;
  color: ${theme.colors.white};
`;

export default Nav;
